import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarAhorro } from '../../actions/asesorias';

const EliminarAhorro = ({ ahorro, reestablecerAhorro }) => {

    const dispatch = useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const handleProcesar = async () => {
        await setStatusProcesar(true);
        await dispatch(eliminarAhorro({ id_asesoria: ahorro.id_asesoria, id_ahorro: ahorro.id_ahorro }));
        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if (!statusProcesar) {
            reestablecerAhorro(null);
            setEliminarModal(false);
        }
    }

    useEffect(() => {
        if (ahorro != null) {
            setEliminarModal(true);
        }
    }, [ahorro]);

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar ahorro</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas eliminar el ahorro de <strong>{ahorro?.banco || 'Sin definir'}</strong>?</p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={statusProcesar}><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Sí</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Sí</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarAhorro;
